/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResponseData_Array_FaqResponse } from '../models/ResponseData_Array_FaqResponse';
import type { ResponseData_Boolean } from '../models/ResponseData_Boolean';
import type { ResponseData_Int32 } from '../models/ResponseData_Int32';
import type { ResponseData_MessageResponse } from '../models/ResponseData_MessageResponse';
import type { ResponseData_PagedResponse_MessageResponse } from '../models/ResponseData_PagedResponse_MessageResponse';
import type { ResponseData_PagedResponse_TicketResponse } from '../models/ResponseData_PagedResponse_TicketResponse';
import type { ResponseData_TicketResponse } from '../models/ResponseData_TicketResponse';
import type { TicketCategoryEnum } from '../models/TicketCategoryEnum';
import type { TicketStatusEnum } from '../models/TicketStatusEnum';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SupportService {
    /**
     * Получить обращение
     * @returns ResponseData_TicketResponse OK
     * @throws ApiError
     */
    public static getApiV1SupportTicket({
        id,
    }: {
        id: string,
    }): CancelablePromise<ResponseData_TicketResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/support/ticket/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Получить список обращений
     * @returns ResponseData_PagedResponse_TicketResponse OK
     * @throws ApiError
     */
    public static getApiV1SupportTicketList({
        statusId,
        categoryId,
        dateFrom,
        dateTo,
        pageNumber,
        pageSize,
    }: {
        statusId?: TicketStatusEnum,
        categoryId?: TicketCategoryEnum,
        dateFrom?: string,
        dateTo?: string,
        pageNumber?: number,
        pageSize?: number,
    }): CancelablePromise<ResponseData_PagedResponse_TicketResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/support/ticket/list',
            query: {
                'statusId': statusId,
                'categoryId': categoryId,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Получить сообщения обращения
     * @returns ResponseData_PagedResponse_MessageResponse OK
     * @throws ApiError
     */
    public static getApiV1SupportTicketMessage({
        id,
    }: {
        id: string,
    }): CancelablePromise<ResponseData_PagedResponse_MessageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/support/ticket/{id}/message',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Получить список сообщений личного чата
     * @returns ResponseData_PagedResponse_MessageResponse OK
     * @throws ApiError
     */
    public static getApiV1SupportMessageList({
        pageNumber,
        pageSize,
    }: {
        pageNumber?: number,
        pageSize?: number,
    }): CancelablePromise<ResponseData_PagedResponse_MessageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/support/message/list',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Получить сообщение
     * @returns ResponseData_MessageResponse OK
     * @throws ApiError
     */
    public static getApiV1SupportMessage({
        id,
    }: {
        /**
         * Идентификатор сообщения
         */
        id: string,
    }): CancelablePromise<ResponseData_MessageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/support/message/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Получить вложение к сообщению
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiV1SupportMessageAttachment({
        id,
    }: {
        /**
         * Идентификатор вложения
         */
        id: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/support/message/attachment/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Получить список FAQ
     * @returns ResponseData_Array_FaqResponse OK
     * @throws ApiError
     */
    public static getApiV1SupportFaqList(): CancelablePromise<ResponseData_Array_FaqResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/support/faq/list',
        });
    }
    /**
     * Создание обращения
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1SupportTicketCreate({
        formData,
    }: {
        formData?: {
            applicationId?: string;
            categoryId?: TicketCategoryEnum;
            subject?: string;
            message?: string;
            files?: Array<Blob>;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/support/ticket/create',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Переоткрыть обращение
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1SupportTicketReopen({
        formData,
    }: {
        formData?: {
            id?: string;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/support/ticket/reopen',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Прочитать сообщения
     * @returns ResponseData_Int32 OK
     * @throws ApiError
     */
    public static postApiV1SupportMessageRead({
        formData,
    }: {
        formData?: {
            ids?: Array<string>;
        },
    }): CancelablePromise<ResponseData_Int32> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/support/message/read',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Отправить сообщение
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1SupportMessageSend({
        formData,
    }: {
        formData?: {
            text?: string;
            files?: Array<Blob>;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/support/message/send',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Отправить сообщение для обращения
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1SupportTicketMessageSend({
        formData,
    }: {
        formData?: {
            ticketId?: string;
            text?: string;
            files?: Array<Blob>;
        },
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/support/ticket/message/send',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * SignalR Message Hub — инструкция по использованию.
     *
     * Клиентам необходимо подключаться к SignalR-хабу по адресу:
     * `https://your-server.com/messageHub`
     *
     * После установления соединения клиент должен в течение 5 сек вызвать метод:
     * ```
     * connection.invoke("AuthorizeConnection", token);
     *
     * ```
     * где `token` — пользовательский access token, выданный вашим API.
     * По истечении указанного временного интервала соединение будет разорвано.
     *
     *
     * После авторизации сервер может вызывать следующие методы на клиенте:<list type="bullet">
     * <item><description><b>ReceiveMessage(message)</b> — получение сообщения.</description></item>
     * <item><description><b>ForceDisconnect(reason)</b> — сервер принудительно завершает соединение.</description></item></list>
     *
     * Рекомендуется на стороне клиента использовать SignalR с автоматическим переподключением:
     *
     * Пример клиента на TypeScript:
     *
     *
     * const connection = new signalR.HubConnectionBuilder()
     * .withUrl("https://your-server.com/messageHub", {
         * transport: signalR.HttpTransportType.WebSockets,
         * skipNegotiation: true
         * })
         * .withAutomaticReconnect()
         * .build();
         *
         * await connection.start();
         * await connection.invoke("AuthorizeConnection", token);
         *
         * connection.on("ReceiveMessage", n => console.log("Message:", n));
         * connection.on("ForceDisconnect", msg => connection.stop());
         *
         *
         * Подключение можно закрыть вызовом:```await connection.stop();```
         *
         * Этот эндпоинт не выполняет действий, служит только как документация для Swagger.
         * @returns any Описание успешно возвращено
         * @throws ApiError
         */
        public static getApiV1SupportHubInfo(): CancelablePromise<any> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/v1/support/hub-info',
            });
        }
    }
